export enum OrganizationSize {
  MICRO = 'micro',
  EXTRA_SMALL = 'extra_small',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRA_LARGE = 'extra_large',
}

export const TOTAL_STEPS = 2;
